function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 84.5,
  cy: 80.5,
  rx: 84.5,
  ry: 80.5,
  fill: "#8BCBEB"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.7328 18.8163L22.168 34.6711L45.1627 136.767L122.727 120.913L99.7328 18.8163Z",
  fill: "#E0E0E0"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("path", {
  opacity: 0.5,
  d: "M98.812 20.8104L23.8687 36.1294L46.0861 134.775L121.029 119.456L98.812 20.8104Z",
  fill: "url(#paint0_linear)"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.9875 64.7268C11.7424 64.7268 12.3544 64.1438 12.3544 63.4246C12.3544 62.7055 11.7424 62.1225 10.9875 62.1225C10.2326 62.1225 9.62061 62.7055 9.62061 63.4246C9.62061 64.1438 10.2326 64.7268 10.9875 64.7268Z",
  fill: "#6CC566"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M98.0202 21.7316L24.9849 36.6605L46.7114 133.126L119.747 118.197L98.0202 21.7316Z",
  fill: "white"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M78.7725 21.2915L42.5405 28.6975L44.4237 37.0587L80.6556 29.6527L78.7725 21.2915Z",
  fill: "url(#paint1_linear)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.8161 16.8281C56.0188 17.4005 54.249 20.0757 54.8643 22.8029C55.4797 25.53 58.2443 27.2801 61.0362 26.7077C63.8281 26.1353 65.6034 23.46 64.988 20.7329C64.3726 18.0057 61.6135 16.2557 58.8161 16.8281ZM60.5715 24.6273C59.9803 24.7616 59.3605 24.7252 58.7911 24.5227C58.2217 24.3202 57.7285 23.9608 57.3743 23.4902C57.0202 23.0197 56.8211 22.4593 56.8024 21.8806C56.7838 21.3019 56.9465 20.7309 57.2697 20.2406C57.5929 19.7503 58.0621 19.3627 58.6174 19.1273C59.1727 18.892 59.789 18.8194 60.3877 18.919C60.9864 19.0185 61.5405 19.2857 61.9793 19.6863C62.4181 20.087 62.7217 20.603 62.8515 21.1687C62.9411 21.5384 62.9532 21.9214 62.887 22.2956C62.8209 22.6699 62.6778 23.028 62.4659 23.3493C62.2541 23.6707 61.9776 23.9491 61.6525 24.1684C61.3274 24.3877 60.9601 24.5436 60.5715 24.6273V24.6273Z",
  fill: "url(#paint2_linear)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M78.3101 21.0109L42.8413 28.261L44.6414 36.2536L80.1102 29.0035L78.3101 21.0109Z",
  fill: "#6CC566"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.8156 16.8281C57.8352 17.0285 56.9392 17.5014 56.2409 18.187C55.5427 18.8726 55.0735 19.74 54.8927 20.6796C54.7119 21.6192 54.8276 22.5888 55.2252 23.4657C55.6228 24.3427 56.2844 25.0876 57.1265 25.6063C57.9685 26.1251 58.953 26.3943 59.9556 26.38C60.9582 26.3656 61.9339 26.0684 62.7592 25.5258C63.5845 24.9833 64.2223 24.2198 64.5921 23.3318C64.962 22.4439 65.0471 21.4715 64.8368 20.5375C64.6971 19.9172 64.4306 19.3293 64.0524 18.8072C63.6742 18.2851 63.1918 17.8391 62.6327 17.4947C62.0735 17.1502 61.4487 16.914 60.7937 16.7997C60.1388 16.6853 59.4666 16.6949 58.8156 16.8281V16.8281ZM60.4929 24.2814C59.927 24.3971 59.3378 24.3503 58.7998 24.147C58.2619 23.9436 57.7993 23.5929 57.4706 23.1391C57.1418 22.6853 56.9618 22.1488 56.9531 21.5975C56.9445 21.0461 57.1076 20.5048 57.422 20.0418C57.7363 19.5788 58.1877 19.2151 58.7191 18.9965C59.2504 18.7779 59.8379 18.7144 60.4071 18.8139C60.9764 18.9134 61.5019 19.1715 61.9172 19.5556C62.3324 19.9396 62.6189 20.4324 62.7402 20.9715C62.9028 21.6943 62.7574 22.4491 62.336 23.0698C61.9146 23.6905 61.2516 24.1263 60.4929 24.2814V24.2814Z",
  fill: "#6CC566"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M135.764 31.4581H56.4341V135.878H135.764V31.4581Z",
  fill: "#E0E0E0"
});

var _ref12 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("path", {
  opacity: 0.5,
  d: "M134.425 33.2238H57.7759V134.114H134.425V33.2238Z",
  fill: "url(#paint3_linear)"
}));

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M133.448 33.9674H58.7505V132.629H133.448V33.9674Z",
  fill: "white"
});

var _ref14 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M78.6597 60.6992C78.5116 60.6992 78.4375 60.6121 78.4375 60.4378C78.4375 60.3299 78.4811 60.2469 78.5682 60.1888C78.6553 60.1223 78.773 60.0891 78.9211 60.0891H79.3393L80.8816 52.7181L80.4502 52.6558C80.1279 52.606 79.9667 52.4774 79.9667 52.2698C79.9667 52.1204 80.0277 52.0457 80.1496 52.0457H82.4499L84.5411 58.6324C84.6108 58.8565 84.6674 59.1138 84.711 59.4043C84.7633 59.6866 84.7938 59.8733 84.8025 59.9646H84.8809C84.8896 59.8733 84.9158 59.6866 84.9593 59.4043C85.0116 59.1138 85.0682 58.8565 85.1292 58.6324L87.0897 52.0457H89.39C89.512 52.0457 89.573 52.1204 89.573 52.2698C89.573 52.4774 89.4118 52.606 89.0894 52.6558L88.6581 52.7181L90.331 60.0767L90.9061 60.2012C91.1414 60.251 91.259 60.3548 91.259 60.5125C91.259 60.637 91.2111 60.6992 91.1152 60.6992H88.462C88.3923 60.6992 88.3357 60.6785 88.2921 60.637C88.2573 60.5872 88.2399 60.5208 88.2399 60.4378C88.2399 60.3299 88.2834 60.2469 88.3706 60.1888C88.4577 60.1223 88.5753 60.0891 88.7234 60.0891H89.2985L87.8347 53.5523C87.7998 53.4195 87.7693 53.2659 87.7432 53.0916C87.7258 52.9173 87.7171 52.8052 87.7171 52.7554H87.6517C87.643 52.8052 87.6169 52.909 87.5733 53.0667C87.5384 53.2161 87.4992 53.378 87.4557 53.5523L85.3384 60.6992H84.1229L81.8487 53.5523C81.8052 53.4195 81.7616 53.2659 81.718 53.0916C81.6832 52.9173 81.6614 52.8052 81.6527 52.7554H81.5873C81.5873 52.8052 81.5743 52.9173 81.5481 53.0916C81.5307 53.2659 81.5089 53.4195 81.4828 53.5523L80.1366 60.0767L80.8816 60.2261C81.1255 60.2676 81.2475 60.3672 81.2475 60.5249C81.2475 60.6411 81.1996 60.6992 81.1037 60.6992H78.6597ZM95.1045 60.8487C94.4858 60.8487 93.9413 60.7242 93.4707 60.4751C93.0002 60.2178 92.6343 59.8526 92.3729 59.3794C92.1115 58.9063 91.9808 58.3501 91.9808 57.711C91.9808 56.7232 92.2509 55.9388 92.7911 55.3577C93.3313 54.7767 94.0676 54.4861 94.9999 54.4861C95.8451 54.4861 96.5117 54.7227 96.9995 55.1959C97.4875 55.669 97.7314 56.2999 97.7314 57.0884C97.7314 57.3457 97.6748 57.6072 97.5615 57.8728H92.9741C92.9741 58.6365 93.1789 59.2217 93.5884 59.6285C93.9979 60.0352 94.5163 60.2386 95.1437 60.2386C95.4748 60.2386 95.771 60.2012 96.0324 60.1265C96.3025 60.0435 96.5683 59.9148 96.8296 59.7405C96.847 59.7322 96.8819 59.7115 96.9342 59.6783C96.9952 59.6451 97.0518 59.6285 97.1041 59.6285C97.1825 59.6285 97.2478 59.6575 97.3001 59.7156C97.3524 59.7737 97.3785 59.8443 97.3785 59.9273C97.3785 60.0767 97.2435 60.2303 96.9734 60.388C96.4332 60.6951 95.8102 60.8487 95.1045 60.8487ZM96.6858 57.2503C96.7207 57.1756 96.7381 57.0594 96.7381 56.9017C96.7381 56.3289 96.5769 55.8848 96.2546 55.5694C95.9322 55.254 95.5053 55.0962 94.9738 55.0962C94.4161 55.0962 93.9543 55.2913 93.5884 55.6814C93.2224 56.0633 93.0177 56.5862 92.9741 57.2503H96.6858ZM98.8004 60.6992C98.661 60.6992 98.5913 60.6162 98.5913 60.4502C98.5913 60.3423 98.6305 60.2593 98.7089 60.2012C98.7961 60.1431 98.9094 60.114 99.0488 60.114H99.4539V55.1959H98.8004C98.661 55.1959 98.5913 55.1128 98.5913 54.9468C98.5913 54.8306 98.6305 54.7476 98.7089 54.6978C98.7961 54.6397 98.9094 54.6106 99.0488 54.6106H100.382V55.4822H100.421C101.162 54.8182 101.924 54.4861 102.708 54.4861C103.327 54.4861 103.837 54.6605 104.237 55.0091C104.638 55.3494 104.839 55.8143 104.839 56.4036V60.114L105.466 60.251C105.701 60.3008 105.819 60.4004 105.819 60.5498C105.819 60.6494 105.767 60.6992 105.662 60.6992H103.205C103.066 60.6992 102.996 60.6162 102.996 60.4502C102.996 60.3423 103.035 60.2593 103.113 60.2012C103.201 60.1431 103.314 60.114 103.453 60.114H103.858V56.4783C103.858 56.0716 103.732 55.7479 103.479 55.5071C103.235 55.2581 102.883 55.1336 102.421 55.1336C102.081 55.1336 101.737 55.2249 101.388 55.4075C101.04 55.5818 100.722 55.8226 100.434 56.1297V60.114L101.062 60.251C101.183 60.2759 101.271 60.3133 101.323 60.3631C101.384 60.4046 101.414 60.4668 101.414 60.5498C101.414 60.6494 101.362 60.6992 101.258 60.6992H98.8004ZM109.309 60.8487C108.69 60.8487 108.181 60.6785 107.78 60.3382C107.379 59.9895 107.179 59.5164 107.179 58.9187V55.1959H106.525C106.386 55.1959 106.316 55.1128 106.316 54.9468C106.316 54.8306 106.355 54.7476 106.434 54.6978C106.521 54.6397 106.634 54.6106 106.773 54.6106H108.159V58.844C108.159 59.2508 108.281 59.5786 108.525 59.8277C108.777 60.0767 109.135 60.2012 109.596 60.2012C109.936 60.2012 110.276 60.1099 110.616 59.9273C110.964 59.7447 111.282 59.4998 111.57 59.1927V55.1959H110.917C110.777 55.1959 110.707 55.1128 110.707 54.9468C110.707 54.8306 110.747 54.7476 110.825 54.6978C110.912 54.6397 111.025 54.6106 111.165 54.6106H112.55V60.114L113.073 60.251C113.195 60.2842 113.282 60.3257 113.334 60.3755C113.395 60.417 113.426 60.4751 113.426 60.5498C113.426 60.6494 113.374 60.6992 113.269 60.6992H111.622V59.8526H111.583C110.842 60.5166 110.084 60.8487 109.309 60.8487Z",
  fill: "#6D7380"
}));

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M114.726 29.689H77.6689V38.2405H114.726V29.689Z",
  fill: "url(#paint4_linear)"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M96.1973 21.3416C93.3365 21.3416 91.0166 23.6035 91.0166 26.3947C91.0166 29.1858 93.3365 31.4477 96.1973 31.4477C99.0582 31.4477 101.378 29.1858 101.378 26.3947C101.378 23.6035 99.0582 21.3416 96.1973 21.3416ZM96.1973 29.3103C95.5891 29.3241 94.9904 29.1648 94.4777 28.8529C93.9649 28.541 93.5614 28.0906 93.3186 27.5592C93.0757 27.0278 93.0047 26.4395 93.1144 25.8694C93.2242 25.2994 93.5098 24.7734 93.9348 24.3587C94.3598 23.944 94.9049 23.6594 95.5004 23.5412C96.096 23.4229 96.7151 23.4765 97.2785 23.695C97.842 23.9135 98.3244 24.287 98.664 24.7679C99.0036 25.2487 99.1851 25.8151 99.1852 26.3947C99.1911 27.1564 98.88 27.8893 98.32 28.4331C97.7601 28.9769 96.9969 29.2873 96.1973 29.2965V29.3103Z",
  fill: "url(#paint5_linear)"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M114.336 29.3224H78.0596V37.4969H114.336V29.3224Z",
  fill: "#008DD5"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M96.1974 21.3416C95.1947 21.3416 94.2144 21.6249 93.3807 22.1556C92.5469 22.6863 91.8971 23.4407 91.5134 24.3232C91.1296 25.2058 91.0292 26.1769 91.2249 27.1139C91.4205 28.0508 91.9034 28.9114 92.6124 29.5869C93.3215 30.2624 94.2248 30.7224 95.2083 30.9088C96.1918 31.0951 97.2112 30.9995 98.1376 30.6339C99.064 30.2683 99.8559 29.6493 100.413 28.855C100.97 28.0607 101.267 27.1269 101.267 26.1716C101.267 24.8906 100.733 23.6621 99.7825 22.7563C98.8316 21.8505 97.5421 21.3416 96.1974 21.3416ZM96.1974 28.9592C95.6191 28.9586 95.054 28.7947 94.5735 28.4882C94.0929 28.1818 93.7184 27.7466 93.4973 27.2376C93.2761 26.7285 93.2183 26.1685 93.331 25.6282C93.4438 25.0878 93.722 24.5914 94.1307 24.2016C94.5393 23.8118 95.06 23.5461 95.6271 23.4381C96.1941 23.33 96.7821 23.3844 97.3167 23.5945C97.8513 23.8045 98.3086 24.1607 98.6308 24.6182C98.9531 25.0756 99.1258 25.6138 99.1272 26.1647C99.127 26.5309 99.051 26.8935 98.9036 27.2317C98.7562 27.57 98.5403 27.8772 98.2683 28.1359C97.9962 28.3947 97.6733 28.5998 97.3179 28.7396C96.9626 28.8793 96.5819 28.9511 96.1974 28.9506V28.9592Z",
  fill: "#008DD5"
});

var _ref19 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("path", {
  opacity: 0.5,
  d: "M13.0751 138.7H12.3926V142.389H13.0751V138.7Z",
  fill: "#008DD5"
}), React.createElement("path", {
  opacity: 0.5,
  d: "M14.6704 140.871V140.22H10.7985V140.871H14.6704Z",
  fill: "#008DD5"
}));

var _ref20 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("path", {
  opacity: 0.5,
  d: "M92.2602 11.2406H91.5776V14.9292H92.2602V11.2406Z",
  fill: "#47E6B1"
}), React.createElement("path", {
  opacity: 0.5,
  d: "M93.856 13.4092V12.7589H89.984V13.4092H93.856Z",
  fill: "#47E6B1"
}));

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.5,
  d: "M149.592 144.841C149.403 144.763 149.252 144.622 149.166 144.444C149.08 144.267 149.065 144.065 149.125 143.878C149.135 143.849 149.141 143.82 149.143 143.79V143.79C149.149 143.704 149.125 143.619 149.076 143.547C149.026 143.475 148.954 143.421 148.87 143.391C148.785 143.361 148.693 143.358 148.606 143.382C148.52 143.407 148.444 143.457 148.39 143.525V143.525C148.371 143.549 148.355 143.575 148.343 143.603C148.261 143.782 148.112 143.927 147.926 144.009C147.74 144.091 147.528 144.104 147.332 144.047C147.302 144.038 147.27 144.032 147.239 144.03V144.03C147.149 144.025 147.06 144.048 146.984 144.094C146.909 144.141 146.851 144.21 146.82 144.291C146.789 144.371 146.786 144.459 146.811 144.541C146.837 144.624 146.889 144.696 146.961 144.748V144.748C146.987 144.766 147.014 144.781 147.043 144.793C147.231 144.871 147.383 145.012 147.469 145.19C147.555 145.367 147.569 145.569 147.509 145.756C147.5 145.785 147.494 145.814 147.491 145.844V145.844C147.486 145.93 147.51 146.015 147.559 146.087C147.608 146.159 147.68 146.213 147.765 146.243C147.849 146.273 147.942 146.276 148.028 146.251C148.114 146.227 148.19 146.177 148.245 146.109V146.109C148.264 146.085 148.279 146.059 148.292 146.031C148.374 145.852 148.522 145.707 148.709 145.625C148.895 145.543 149.107 145.53 149.303 145.587C149.333 145.596 149.364 145.602 149.396 145.604C149.485 145.609 149.575 145.586 149.65 145.539C149.725 145.493 149.783 145.424 149.814 145.343C149.845 145.263 149.848 145.175 149.823 145.092C149.798 145.01 149.745 144.938 149.673 144.886V144.886C149.648 144.868 149.621 144.853 149.592 144.841V144.841Z",
  fill: "#4D8AF0"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.4299 109.38C34.2417 109.302 34.0901 109.16 34.0041 108.983C33.9181 108.805 33.9036 108.604 33.9634 108.416C33.9731 108.388 33.9791 108.358 33.9816 108.328V108.328C33.987 108.243 33.9633 108.158 33.914 108.086C33.8648 108.014 33.7925 107.959 33.708 107.929C33.6235 107.9 33.5312 107.897 33.4448 107.921C33.3584 107.945 33.2825 107.995 33.2282 108.064V108.064C33.2093 108.088 33.1935 108.114 33.181 108.141C33.0991 108.321 32.9508 108.465 32.7643 108.547C32.5779 108.629 32.3664 108.643 32.1699 108.586C32.1399 108.577 32.1088 108.571 32.0774 108.569V108.569C31.9875 108.563 31.8982 108.586 31.8228 108.633C31.7474 108.68 31.6899 108.749 31.6587 108.829C31.6275 108.91 31.6244 108.998 31.6498 109.08C31.6752 109.162 31.7277 109.235 31.7996 109.286V109.286C31.8249 109.304 31.8523 109.319 31.8813 109.331C32.0696 109.409 32.2211 109.551 32.3071 109.728C32.3932 109.906 32.4076 110.107 32.3478 110.294C32.3382 110.323 32.3321 110.353 32.3297 110.383C32.3243 110.468 32.3479 110.553 32.3972 110.625C32.4465 110.697 32.5187 110.752 32.6032 110.781C32.6877 110.811 32.78 110.814 32.8664 110.79C32.9528 110.766 33.0288 110.716 33.083 110.647V110.647C33.1019 110.623 33.1177 110.597 33.1302 110.569C33.2122 110.39 33.3605 110.246 33.5469 110.164C33.7333 110.082 33.9449 110.068 34.1413 110.125C34.1713 110.134 34.2024 110.14 34.2339 110.142C34.3238 110.147 34.413 110.125 34.4884 110.078C34.5638 110.031 34.6214 109.962 34.6525 109.882C34.6837 109.801 34.6868 109.713 34.6614 109.631C34.636 109.549 34.5835 109.476 34.5116 109.425V109.425C34.4863 109.407 34.4589 109.392 34.4299 109.38Z",
  fill: "white"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M130.35 23.0311C130.162 22.9531 130.01 22.8118 129.924 22.6342C129.838 22.4566 129.824 22.255 129.883 22.0679C129.893 22.0393 129.899 22.0097 129.902 21.9797C129.907 21.8941 129.883 21.809 129.834 21.7372C129.785 21.6654 129.712 21.6106 129.628 21.5809C129.543 21.5512 129.451 21.5482 129.365 21.5724C129.278 21.5966 129.202 21.6466 129.148 21.7151C129.129 21.7392 129.113 21.7653 129.101 21.7929C129.019 21.9723 128.871 22.1167 128.684 22.1986C128.498 22.2806 128.286 22.2944 128.09 22.2374C128.06 22.2282 128.029 22.2224 127.997 22.2201C127.907 22.2149 127.818 22.2375 127.743 22.2844C127.667 22.3313 127.61 22.4001 127.579 22.4807C127.547 22.5612 127.544 22.6491 127.57 22.7314C127.595 22.8137 127.648 22.8861 127.72 22.9378C127.745 22.9557 127.772 22.9708 127.801 22.9827C127.989 23.0608 128.141 23.2021 128.227 23.3797C128.313 23.5573 128.328 23.7588 128.268 23.9459C128.258 23.9746 128.252 24.0042 128.25 24.0341C128.244 24.1198 128.268 24.2048 128.317 24.2767C128.366 24.3485 128.439 24.4033 128.523 24.433C128.608 24.4627 128.7 24.4656 128.786 24.4415C128.873 24.4173 128.949 24.3672 129.003 24.2987C129.022 24.2746 129.038 24.2485 129.05 24.2209C129.132 24.0416 129.28 23.8972 129.467 23.8152C129.653 23.7333 129.865 23.7195 130.061 23.7765C130.091 23.7857 130.122 23.7915 130.154 23.7938C130.244 23.7989 130.333 23.7764 130.408 23.7294C130.484 23.6825 130.541 23.6137 130.572 23.5332C130.604 23.4527 130.607 23.3648 130.581 23.2824C130.556 23.2001 130.503 23.1278 130.432 23.0761C130.406 23.0581 130.379 23.043 130.35 23.0311Z",
  fill: "#F7BCAE"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M157.135 66.9248C157.89 66.9248 158.502 66.3418 158.502 65.6226C158.502 64.9034 157.89 64.3204 157.135 64.3204C156.381 64.3204 155.769 64.9034 155.769 65.6226C155.769 66.3418 156.381 66.9248 157.135 66.9248Z",
  fill: "#6CC566"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.5,
  d: "M51.5041 141.663C52.259 141.663 52.871 141.08 52.871 140.361C52.871 139.641 52.259 139.058 51.5041 139.058C50.7492 139.058 50.1372 139.641 50.1372 140.361C50.1372 141.08 50.7492 141.663 51.5041 141.663Z",
  fill: "#EE6C4D"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.5,
  d: "M143.098 95.0713C143.853 95.0713 144.465 94.4883 144.465 93.7691C144.465 93.0499 143.853 92.4669 143.098 92.4669C142.343 92.4669 141.731 93.0499 141.731 93.7691C141.731 94.4883 142.343 95.0713 143.098 95.0713Z",
  fill: "white"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.5,
  d: "M25.4391 29.2048C26.1941 29.2048 26.806 28.6218 26.806 27.9026C26.806 27.1835 26.1941 26.6005 25.4391 26.6005C24.6842 26.6005 24.0723 27.1835 24.0723 27.9026C24.0723 28.6218 24.6842 29.2048 25.4391 29.2048Z",
  fill: "#008DD5"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.5,
  d: "M12.6213 15.4014C13.3762 15.4014 13.9882 14.8184 13.9882 14.0992C13.9882 13.38 13.3762 12.797 12.6213 12.797C11.8664 12.797 11.2544 13.38 11.2544 14.0992C11.2544 14.8184 11.8664 15.4014 12.6213 15.4014Z",
  fill: "#EE6C4D"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M133.154 11.251C133.909 11.251 134.521 10.668 134.521 9.9488C134.521 9.22963 133.909 8.64662 133.154 8.64662C132.399 8.64662 131.787 9.22963 131.787 9.9488C131.787 10.668 132.399 11.251 133.154 11.251Z",
  fill: "#6CC566"
});

var _ref30 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 83.5569,
  y1: 127.115,
  x2: 63.3107,
  y2: 28.0672,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 19942.2,
  y1: -2461.5,
  x2: 19857.4,
  y2: -2876.65,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 5830,
  y1: 293.288,
  x2: 5711.61,
  y2: -285.883,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 36573.4,
  y1: 71718.9,
  x2: 36573.4,
  y2: 12858.4,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 17751.4,
  y1: 1364.84,
  x2: 17751.4,
  y2: 941.964,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 7000.66,
  y1: 1803.97,
  x2: 7000.66,
  y2: 1213.36,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 35.0344,
  height: 8.99248,
  fill: "white",
  transform: "translate(78.4189 51.8797)"
})));

var SvgEmptyMenu = function SvgEmptyMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 169,
    height: 161,
    viewBox: "0 0 169 161",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEmptyMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EmptyMenu.2e8ef39e.svg";
export { ForwardRef as ReactComponent };